import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from '../architecture/frontend/index'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import {useState} from 'react'


const Report = (props) => {
  const [date, setDate] = useState(null)
  //const value = props.report.startDate && new Date(props.report.startDate)
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='f6 white' icon={faTruck} />
          <div className='pl2 fw7 f6 white'>Excel All Claims Report Download</div>
          <div className='h2'></div>
        </div>
      </div>
      <div className='pt5 flex flex-column items-center'>
        Choose a starting date
        <div className='w4 mt2 ba b--moon-gray'>
          <DatePicker 
            className='w-100 tc pa2 bn b--moon-gray input-reset' 
            selected={date && new Date(date)} 
            onChange={e => setDate(moment(e).toISOString())}
          />
        </div>
        <div className='flex justify-center'>
          <div 
            className={'mt4 dib br3 ph3 pv2 bg-evonik-purple white pointer' + (date ? '' : ' bg-moon-gray ')}
            onClick={e => date && Dispatch.nextAction('reports.downloadExcelAllClaimsReport', {startingDate: date, claimsOnly: false})}>
              Download All Data
          </div>
          <div className='pl2'></div>
          <div 
            className={'mt4 dib br3 ph3 pv2 bg-evonik-purple white pointer' + (date ? '' : ' bg-moon-gray ')}
            onClick={e => date && Dispatch.nextAction('reports.downloadExcelAllClaimsReport', {startingDate: date, claimsOnly: true})}>
              Download All Claims
          </div>
        </div>
        {props?.company?.id === 3 && 
          <div 
            className={'mt4 dib br3 ph3 pv2 bg-evonik-purple white pointer' + (date ? '' : ' bg-moon-gray ')}
            onClick={e => Dispatch.nextAction('reports.downloadExcelInvoiceRequiredReport', '')}>
              Invoice Required Report
          </div>
        }
    </div>
    </div>
  )
}

export default Report